module.exports = __webpack_public_path__ + "static/img/about.8bb6553a.png";